const topicOptionEl = document.querySelector('.topics-select');
const topicContentEl = document.querySelectorAll('.topic-text');
const successElement = document.querySelector(".custom-form-success");
const errorElement = document.querySelector(".custom-form-error");
const formElement = document.querySelectorAll(".topics-contact-form");

const formActionUrl = "https://script.google.com/macros/s/AKfycbxllRnGwXQcIMlDUTwjDvvl0Kl3NO8j53cD64jdg3XusEqozdx5Nfi7naNyLNPAWKuIYg/exec"

topicOptionEl.addEventListener('change', function () {
  successElement.classList.add("is-hidden")
  errorElement.classList.add("is-hidden")
  const selectedOptionValue = topicOptionEl.value;
  topicContentEl.forEach(function (topicText) {
    const topicLabel = topicText.getAttribute('data-topic-label');
    if (topicLabel === selectedOptionValue) {
      topicText.style.display = 'block';
    } else {
      topicText.style.display = 'none';
    }
  });
});


// Send form data to google sheet for custom input fields of contact form based on selected topic

formElement.forEach(eachFormEl=>{
  eachFormEl.addEventListener("submit", (e) => {
    e.preventDefault();
    const formData = new FormData(eachFormEl)
    formData.append("Topic", topicOptionEl.value)
    // showing loader for that calling global declred function showLoader()
    showLoader()
    successElement.classList.add("is-hidden")
    errorElement.classList.add("is-hidden")
    fetch(formActionUrl, {
      method: 'POST',
      body: formData
    }).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
      }).then(responseData => {
        if (responseData.result === "success") {
          eachFormEl.reset()
          successElement.classList.remove("is-hidden")
        }
        // Hiding loader for that calling global declred function hideLoader()
        hideLoader()
      })
      .catch(error => {
        console.log(error);
        errorElement.classList.remove("is-hidden")
        hideLoader()
      });
  })
  
})
